// TODO: This is ALMOST the same as the mapQueryParams in artworks page, generalize.
const findColorByName = (name, colors) => {
  return colors.find(
    (c) => c.name.toLowerCase().replace("#", "") === name.replace("#", ""),
  )
}

const findColorByValue = (value, colors) => {
  return colors.find((c) => c.id === value)
}

const findCatalogByName = (key, name, filters) => {
  return filters[key]?.find(
    (c) => (c.name ?? c.type).toLowerCase() === name.toLowerCase(),
  )
}

const findCatalogByValue = (key, value, filters) => {
  return filters[key]?.find((v) => v.id === value)
}
/*
 * Retrieve filter query parameters from the URL
 */
export const getQueryParams = (params = {}, filter = {}, filters = {}) => {
  for (const key in params) {
    const value = params[key]
    switch (key) {
      case "minHeight":
      case "maxHeight":
      case "minWidth":
      case "maxWidth":
        filter[key] = value
        break
      case "colors":
        if (Array.isArray(value)) {
          let filteredColors = []
          value.forEach((colorName) => {
            let color = findColorByName(colorName, filters.colors)
            if (color) filteredColors.push(color.id)
          })
          filter[key] = filteredColors
          break
        }
        let color = findColorByName(value, filters.colors)
        if (color) filter[key] = [color.id]
        break
      default:
        if (Array.isArray(value)) {
          let filteredCatalog = []
          value.forEach((catalogName) => {
            let catalog = findCatalogByName(key, catalogName, filters)

            if (catalog) filteredCatalog.push(catalog.id)
          })
          filter[key] = filteredCatalog
          break
        }
        let catalog = findCatalogByName(key, value, filters)
        if (catalog) filter[key] = [catalog.id]
        break
    }
  }

  return filter
}

/*
 * Set filter query parameters in the URL
 */
export const setQueryParams = (filter = {}, router, filters = {}) => {
  let params = []
  for (const key in filter) {
    const values = filter[key]
    let paramValues = []
    if (Array.isArray(values)) {
      values.forEach((value) => {
        let paramValue =
          "colors" === key
            ? findColorByValue(value, filters.colors)
            : findCatalogByValue(key, value, filters)
        if (paramValue)
          paramValues.push(
            (paramValue.name ?? paramValue.type).toLowerCase().replace("#", ""),
          )
      })
    } else {
      values && paramValues.push(values)
    }
    if (paramValues.length > 0) {
      params[key] = paramValues
    }
  }
  if (router.query.id) params.id = router.query.id
  if (router.query.collection) params.collection = router.query.collection
  filter &&
    router.push(
      {
        pathname: router.route,
        query: params,
      },
      undefined,
      {
        shallow: true,
      },
    )
}
